"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// https://en.wikipedia.org/wiki/Hiragana_(Unicode_block)
// http://www.localizingjapan.com/blog/2012/01/20/regular-expressions-for-japanese-text/
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasKanjiLike = exports.isNotKanjiLike = exports.isKanjiLike = exports.isDigit = exports.isHiragana = exports.hasKanji = exports.isNotKanji = exports.isKanji = exports.hasDigit = exports.isLatinDigit = exports.isFullWidthDigit = void 0;
const JOYO_KANJI_EXTRA = 0x20b9f;
const KANJI_START = 0x4e00;
const KANJI_END = 0x9faf;
const WIDE_DIGIT_START = "０".codePointAt(0);
const WIDE_DIGIT_END = "９".codePointAt(0);
const DIGIT_START = "0".codePointAt(0);
const DIGIT_END = "9".codePointAt(0);
// const HIRAGANA_START = 0x3040;
// const HIRAGANA_END = 0x309f;
const HIRAGANA_KANA_START = 0x3041;
const HIRAGANA_KANA_END = 0x3096;
function inRange(ch, start, end) {
    const code = ch.codePointAt(0);
    return code ? start <= code && code <= end : false;
}
const isFullWidthDigit = (ch) => inRange(ch, WIDE_DIGIT_START, WIDE_DIGIT_END);
exports.isFullWidthDigit = isFullWidthDigit;
const isLatinDigit = (ch) => inRange(ch, DIGIT_START, DIGIT_END);
exports.isLatinDigit = isLatinDigit;
const hasDigit = (text) => Array.prototype.some.call(text || "", exports.isDigit);
exports.hasDigit = hasDigit;
const isKanji = (ch) => ch.codePointAt(0) === JOYO_KANJI_EXTRA || inRange(ch, KANJI_START, KANJI_END);
exports.isKanji = isKanji;
const isNotKanji = (ch) => !exports.isKanji(ch);
exports.isNotKanji = isNotKanji;
const hasKanji = (text) => Array.prototype.some.call(text || "", exports.isKanji);
exports.hasKanji = hasKanji;
function isHiragana(ch) {
    return inRange(ch, HIRAGANA_KANA_START, HIRAGANA_KANA_END);
}
exports.isHiragana = isHiragana;
/**
 * I started by only expecting furigana for kanji chracters, but I
 * found cases in our existing data where authors are using full width
 * numbers instead of kanji.
 * For example: '１' instead of  '一', but still indicating 'いち' as a reading
 *
 * So I am treating full-width numbers as if they are kanji for the sake of parsing.
 */
const isDigit = (ch) => exports.isFullWidthDigit(ch) || exports.isLatinDigit(ch);
exports.isDigit = isDigit;
const isKanjiLike = (ch) => exports.isKanji(ch) || exports.isDigit(ch);
exports.isKanjiLike = isKanjiLike;
const isNotKanjiLike = (ch) => !exports.isKanjiLike(ch);
exports.isNotKanjiLike = isNotKanjiLike;
const hasKanjiLike = (text) => Array.prototype.some.call(text || "", exports.isKanjiLike);
exports.hasKanjiLike = hasKanjiLike;
//# sourceMappingURL=japaneseUtils.js.map